import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { steamLoginUrl } from '../lib/api/scanApi';
import { getStats } from '../lib/api/statsApi';

// Formatte un compteur (ex: 1200 -> "1.2K"), ou "…" tant que la donnée charge.
const fmt = (n) => {
  if (n === null || n === undefined) return '…';
  if (n >= 1000) return (n / 1000).toFixed(n % 1000 === 0 ? 0 : 1) + 'K';
  return String(n);
};

function SteamIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 0C5.6 0 .4 4.9 0 11.1l6.4 2.7a3.4 3.4 0 0 1 1.9-.6h.2l2.9-4.2v-.1a4.5 4.5 0 1 1 4.5 4.5h-.1l-4.1 3a3.4 3.4 0 0 1-6.7.8L.5 19.6A12 12 0 1 0 12 0zM7.5 18.2l-1.5-.6a2.6 2.6 0 0 0 4.8-1 2.6 2.6 0 0 0-3.5-2.4l1.5.6a1.9 1.9 0 1 1-1.3 3.4zM18 8.5A3 3 0 1 0 15 11.5 3 3 0 0 0 18 8.5zm-5.2 0a2.3 2.3 0 1 1 2.3 2.2 2.3 2.3 0 0 1-2.3-2.2z" />
    </svg>
  );
}

function Stat({ value, label, href, tone }) {
  return (
    <a className={`stat stat--link stat--${tone}`} href={href}>
      <div className="stat__value">{value}</div>
      <div className="stat__label">{label}</div>
    </a>
  );
}

function Landing() {
  const { t } = useTranslation();
  const error = useSelector((s) => s.scan.error);
  const [stats, setStats] = useState(null);

  // Chiffres en direct depuis la base de risque + rafraîchissement auto (imports n8n, etc.).
  useEffect(() => {
    let alive = true;
    const fetchStats = () =>
      getStats()
        .then(({ data }) => {
          if (alive) setStats(data);
        })
        .catch(() => {
          /* pas de stats -> les tuiles affichent "…" */
        });

    fetchStats();
    const id = setInterval(fetchStats, 30000); // re-check toutes les 30 s
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);

  const connect = () => {
    window.location.href = steamLoginUrl();
  };

  return (
    <section className="landing">
      <div className="landing__glow" aria-hidden="true" />

      <p className="landing__eyebrow">{t('landing.eyebrow')}</p>
      <h1 className="landing__title">
        <span>{t('landing.title_1')}</span>
        <span className="landing__title-accent">{t('landing.title_2')}</span>
      </h1>
      <p className="landing__subtitle">{t('landing.subtitle')}</p>

      {error && <p className="landing__error">{t('landing.error')}</p>}

      <button type="button" className="btn btn--steam" onClick={connect}>
        <SteamIcon />
        {t('landing.cta')}
      </button>

      <p className="landing__privacy">{t('landing.privacy')}</p>
      <p className="landing__demo">{t('landing.demo_hint')}</p>

      <div className="landing__stats">
        <Stat value={fmt(stats?.total)} label={t('landing.stat_danger')} href="/games?type=danger" tone="danger" />
        <Stat value={fmt(stats?.delisted)} label={t('landing.stat_delisted')} href="/games?type=delisted" tone="critical" />
        <Stat value={fmt(stats?.savable)} label={t('landing.stat_savable')} href="/games?type=safe" tone="safe" />
      </div>
    </section>
  );
}

export default Landing;
